import React from 'react';
import { Redirect, Route } from 'react-router';
import { getUser,getUser2 } from './Auth';

const PublicRoute = ({ component: Component, ...rest }) =>
{
    return (
        <Route {...rest}
            render={props => {
                console.log(window.location.pathname,!getUser2(),!getUser());
                return ((!getUser() || !getUser2()) || window.location.pathname==='/track')? <Component {...props} />
                    : <Redirect to={{ pathname: '/inicio', state: { from: props.location }  }}></Redirect>
            }}
        />
    )
}

export default PublicRoute;